import {
  Button,
  Divider,
  Form,
  Input,
  Layout,
  notification,
  theme,
  Typography,
  Upload,
  UploadFile,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { LoadingSpin } from "../../../components/common/Loading";
import { LPPAXIOS } from "../../../framework/api/core.api";
import axios from "axios";
import Editor from "../../../components/common/Editor/Editor";
import { preventSpaceBar } from "../../../utils/inputOnlyNumber";
import { HContent } from "../../../components/common/HContent";
import { useNavigate } from "react-router-dom";
import { LPPUrls } from "../../../LPPUrls";
import AntdImgCrop from "antd-img-crop";

interface GETUPLOADURL {
  path: string;
  url: string;
}

interface LINKTOOL {
  link: string;
}
interface PARAGRAPH {
  text: string;
}
interface FILE64 {
  caption: string;
  stretched: boolean;
  withBackground: boolean;
  withBorder: boolean;
  file: {
    url: string;
    mimetype: string;
    origin: File;
  };
}
interface Block {
  id: string;
  type: "image" | "paragraph" | "linkTool";
  data: FILE64 | PARAGRAPH | LINKTOOL;
}
interface EditorSave {
  time: number;
  version: string;
  blocks: Block[];
}

const { Header } = Layout;
const { Title } = Typography;

export const CreatePage = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [uploadFileList, setUploadFileList] = useState<UploadFile[]>([]);
  const [api, contextHolder] = notification.useNotification();

  async function uploadImgToS3(
    file: ArrayBuffer,
    type: string,
    url: string,
    path: string
  ) {
    const res = await axios.put(url, file, {
      headers: {
        "Content-Type": type,
      },
    });
    if (res.status === 200) {
      return path;
    }
    return "";
  }

  const handleUploadCompMultiFiles = async () => {
    if (uploadFileList.length === 0) return;
    try {
      const paths: string[] = [];
      for (let i = 0; i < uploadFileList.length; i++) {
        const fileBuffer = await uploadFileList[i].originFileObj?.arrayBuffer();
        const res = await LPPAXIOS.get<GETUPLOADURL[]>(
          `admin/files/upload?type=images&mimeType=${uploadFileList[i].type}&imageUploadTarget=banner&num=1`
        );
        if (res.status === 200) {
          const path = await uploadImgToS3(
            fileBuffer!,
            uploadFileList[i].type!,
            res.data[0].url,
            res.data[0].path
          );
          paths.push(path);
        }
      }

      return paths;
    } catch (error) {
    } finally {
    }
  };

  const handleConvertEditorBlocks = async () => {
    if (!data) return;
    const convertArray: any[] = [];
    const { blocks } = data as EditorSave;
    for (let i = 0; i < blocks.length; i++) {
      if (blocks[i].type === "image") {
        const file64 = blocks[i].data as FILE64;
        const arrayBuffer = await file64.file.origin.arrayBuffer();
        const res = await LPPAXIOS.get<GETUPLOADURL[]>(
          `admin/files/upload?type=images&mimeType=${file64.file.mimetype}&imageUploadTarget=banner&num=1`
        );
        if (res.status === 200) {
          const path = await uploadImgToS3(
            arrayBuffer,
            file64.file.mimetype,
            res.data[0].url,
            res.data[0].path
          );
          convertArray.push({
            id: blocks[i].id,
            type: "image",
            data: {
              file: {
                url: path,
              },
            },
            caption: "",
            withBorder: true,
            stretched: false,
            withBackground: false,
          });
        }
      } else if (blocks[i].type === "paragraph") {
        const paragraph = blocks[i].data as PARAGRAPH;
        const text = paragraph.text
          .replaceAll("&nbsp;", "")
          .split(/(<br>)/)
          .filter(Boolean);
        text.forEach((entry, idx) => {
          convertArray.push({
            id: `${blocks[i].id}${idx}`,
            type: blocks[i].type,
            data: {
              text: entry,
            },
          });
        });
        // const text = paragraph.text
        //   .replaceAll("&nbsp;", "")
        //   .replaceAll("<br>", "");
        // convertArray.push({
        //   id: blocks[i].id,
        //   type: blocks[i].type,
        //   data: {
        //     text: text,
        //   },
        // });
      } else if (blocks[i].type === "linkTool") {
        const paragraph = blocks[i].data as LINKTOOL;

        const link = paragraph.link;
        convertArray.push({
          id: blocks[i].id,
          type: blocks[i].type,
          data: {
            link: link,
          },
        });
      }
    }
    return convertArray;
  };
  const handlePostProduct = async (value: any) => {
    if (!data) {
      api.error({
        message: "배너 상세 설명 등록은 필수입니다.",
        description: "이미지 또는 설명을 작성하시기 바랍니다.",
      });
      return;
    }

    if (uploadFileList.length === 0) {
      api.error({
        message: "배너 썸네일 등록은 필수입니다.",
        description: "1개 이상의 이미지를 등록해주세요",
      });
      return;
    }
    try {
      setLoading(true);
      const images = (await handleUploadCompMultiFiles()) ?? [];
      const descriptionEditorData = (await handleConvertEditorBlocks()) ?? [];

      const formData = {
        image: images[0],
        title: value.title.trim(),
        content: descriptionEditorData,
      };
      // console.log(formData);
      // return;

      const res = await LPPAXIOS.post(`/admin/banner`, formData);

      if (res.status === 200) {
        api.success({
          message: `배너 등록을 성공하였습니다.`,
        });
        setTimeout(() => navigate(LPPUrls.Admin.Banner.Main.url()), 500);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        api.error({
          message: `${error.response?.data.message || error.response?.data}`,
          // description: error.response?.data.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      <LoadingSpin loading={loading} />
      <Header
        style={{ background: colorBgContainer }}
        className="drop-shadow-sm"
      >
        <Title>배너 등록</Title>
      </Header>
      <HContent>
        <Form onFinish={handlePostProduct} style={{ width: 800 }}>
          <Form.Item
            label="배너 썸네일"
            required
            tooltip="모바일환경에서 보이는 이미지의 비율을 위해 가로 360px 세로 160px의
            이미지 등록을 권장드립니다."
          >
            <AntdImgCrop aspect={36 / 16}>
              <Upload
                fileList={uploadFileList}
                accept="image/*"
                listType="picture-card"
                showUploadList={{ showPreviewIcon: false }}
                customRequest={({ onSuccess }) => {
                  const res = "Ok";
                  setTimeout(() => {
                    onSuccess!(res);
                  }, 600);
                }}
                onChange={({ fileList }) => {
                  setUploadFileList(fileList);
                }}
              >
                {uploadFileList.length >= 1 ? null : (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                )}
              </Upload>
            </AntdImgCrop>
          </Form.Item>

          <Form.Item
            label="배너제목"
            name="title"
            rules={[
              { required: true, message: "배너 입력은 필수입니다." },
              { min: 10, message: "배너제목 최소 입력글자는 10글자입니다." },
            ]}
          >
            <Input showCount maxLength={100} onInput={preventSpaceBar} />
          </Form.Item>

          <Divider />
          <Typography.Title level={4}>배너 상세 설명</Typography.Title>
          <div className="m-4 w-[100%] p-[5%] bg-[#f4f5f9]">
            <Editor data={data} setData={setData} />
          </div>
          <Form.Item>
            <div className="flex justify-center w-full">
              <Button type="primary" htmlType="submit">
                배너 등록
              </Button>
              {/* <Button onClick={() => console.log(data)}>
                배너사ㅇㅇㅇㅇㅇㅇㅇ항 등록
              </Button> */}
            </div>
          </Form.Item>
        </Form>
      </HContent>
    </>
  );
};
